import { render, staticRenderFns } from "./CountryFlagIcon.vue?vue&type=template&id=708b3de9&scoped=true"
import script from "./CountryFlagIcon.vue?vue&type=script&lang=js"
export * from "./CountryFlagIcon.vue?vue&type=script&lang=js"
import style0 from "./CountryFlagIcon.vue?vue&type=style&index=0&id=708b3de9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b3de9",
  null
  
)

export default component.exports